<div class="rankings-selector">
  <a *ngFor="let ranking of rankings"
    [routerLink]="relativeRouterPath(ranking)"
    class="btn btn-primary {{ ranking.standingsConfig.group ? 'grid-sector grid-sector-' + ranking.standingsConfig.group : ''}}"
    routerLinkActive="active"
    [class.active-grid-sector]="ranking.standingsConfig.group && currentGroupId && ranking.standingsConfig.group == currentGroupId"
  >
    <span *ngIf="ranking.standingsConfig.group" class="grid-group-badge"></span>
    <span class="label">{{ranking.name}}</span>
  </a>
</div>
